<pbc-placeholder></pbc-placeholder>
<div class="call-out" *ngIf="data?.isVisible" data-id="call-out">
  <ng-container *ngIf="data?.content?.html && data?.content?.html.length">{{data?.content?.html | safehtml}}</ng-container>
</div>
